module.exports = {
  /* 01.General */
  "copy.right": "Copyright",
  "general.copyright": "© Inverz Solutions Co., Ltd.",

  "unauthorized.title": "Unauthorized Access Attempt",
  "unauthorized.detail":
    "You are not authorized to view the page you are trying to access.",

  /* 02.User Login, Logout, Register */
  "user.login-title": "Log in with your account.",
  "user.register": "Register",
  "user.forgot-password": "Forgotten Password",
  "user.email": "Email",
  "user.password": "Password",
  "user.forgot-password-question": "Forget password?",
  "user.fullname": "Full Name",
  "user.login-button": "LOGIN",
  "user.register-button": "REGISTER",
  "user.reset-password-button": "RESET",
  "user.reset-password": "Create new password",
  "user.buy": "BUY",
  "user.username": "Username",
  "user.session": "Session expired",
  "user.please-lognin": "Please login again.",
  "user.current-password": "Current Password",
  "user.new-password": "New Password",
  "user.verify-password": "Verify Password",

  /* 03.Menu */
  "menu.dashboard": "Dashboard",
  "menu.report": "Report",
  "menu.rental": "Rental",
  "menu.asset": "Asset",
  "menu.account": "Account",
  "menu.bill": "Rental Bill",
  "menu.company": "Company Profile",
  "menu.asset-manage": "Asset Management",
  "menu.cost": "Utilities Rental Fee",
  "menu.user": "User Management",
  "menu.user-management": "User Management",
  "menu.setting": "Setting",
  "menu.sales": "Sales",

  "menu.home": "Home",
  "menu.app": "Home",
  "menu.dashboards": "Dashboards",
  "menu.gogo": "Gogo",
  "menu.start": "Start",
  "menu.second-menu": "Second Menu",
  "menu.rental-report": "Rental Booking Report",
  "menu.sale-report": "Sale Booking Report",
  "menu.revenue-report": "Revenue Report",
  "menu.guest": "Guest Folio",
  "menu.ui": "UI",
  "menu.charts": "Charts",
  "menu.chat": "Chat",
  "menu.survey": "Survey",
  "menu.todo": "Todo",
  "menu.search": "Search",
  "menu.docs": "Docs",
  "menu.blank-page": "Blank Page",

  /* 04.Error Page */
  "pages.error-title": "Ooops... looks like an error occurred!",
  "pages.error-code": "Error code",
  "pages.go-back-home": "GO BACK HOME",

  // user management //
  "permission.detail": "Permission detail(s)",
  "add.permission": "Add Permission",
  "edit.permission": "Edit Permission",
  "permission.name": "Permission Name *",
  "permission.names": "Permission Name",
  "Permission.feature": "Feature(s)",
  "feature.view": "View",
  "feature.add": "Add/Edit",
  "feature.delete": "Delete",

  "permission.delete": "Delete Permission",
  "delete.detail": "Do you want to delete this permission ?",
  owner: "owner",
  "add.new": "Add New",
  "add.user": "Add User",
  "input.firstName": "First Name",
  "input.lastName": "Last Name",
  "input.gender": "Gender",
  "btn.male": "Male",
  "btn.female": "Female",
  "btn.sale": "For Sale",
  "btn.rent": "For Rent",
  "input.permission": "Permission",
  "input.date": "Date of Birth",
  "input.email": "Email",
  "input.nationality": "Nationality",
  "input.mobile": "Mobile No.",
  "input.address": "Address",
  "user.detail": "User Detail(S)",
  "account.user": "Permission :",
  "name.user": "Sarah Kortney",
  "choise.permission": "Manager",
  "resend.email": "Resend Email Verification",
  "resend.detail": "Do you want to resend this email verification ?",
  "button.no": "No",
  "button.close": "Close",
  "button.yes": "Yes",
  "button.ok": "OK",
  "button.edit": "Edit",
  "button.back": "Back",
  "create.password": "Create Password",
  "reset.password": "Reset Password",
  "error.permission": "Please enter a permission name.",
  "Modal.delete.user": "Delete User",
  "text.delete.user": "Do you want to delete this User ?",
  "input.passport": "ID/Passport No.",
  "alert.permission": "Oops! This user is used.",
  "alert.room": "Oops! This room is used.",
  "alert.asset": "Oops! This asset is used.",
  "alert.user": "Cannot delete because it is currently in use.",
  alert: "Alert !!!",
  "dropdown.select": "Select...",

  // company name //
  "company-name": "Company Name",
  "company.name": "Company Name(ภาษาไทย)",
  "company.name_en": "Company Name(English)",
  "company.information": "Company Information",
  "organization.information": "Organization Information",
  "organization.name.thai": "Organization Name(ภาษาไทย)",
  "organization.name.eng": "Organization Name(English)",
  "organization.license": "Organization License No.",
  "company.address": "Address(ภาษาไทย)",
  "company.address.eng": "Address(English)",
  "company.address2": "Address 2 (ภาษาไทย)",
  "company.address.eng2": "Address 2 (English)",
  "company.country": "Country",
  "company.province": "Province",
  "company.district": "District",
  "company.subdistrict": "Sub District",
  "company.postal": "Postal Code",
  "company.website": "Website",
  "company.phone": "Phone No.",
  "company.fex": "Fax No.",
  "company.room": "Room/Property Limit",
  "company.branch": "Branch No.",
  "company.tax": "TAX ID",
  "company.logo": "Company Logo",
  "same.address": "Same as organization address",
  "upload.logo":
    "*Logo size: wide 1280 px x high 720 px | at least 1 MB (File: *.png)",
  "upload.logo_1": "Upload Logo",

  // company name //
  "add.asset": "Add New Asset",
  "edit.asset": "Edit Asset",
  "add.asset-detail": "Add Asset Details",
  "asset.type": "Asset Type",
  "asset.name": "Asset Name",
  "google.map": "Google Map URL",
  "add.zone": "Add Zone(s)",
  "add.floor": "Add Floor(s)",
  "gallery.upload": "Gallery Upload",
  "upload.file": "Upload File",
  "room.name": "Room/Property Name",
  "heading.room": "Room/Property list",
  "room.detail": "Room/Property Detail(s)",
  "data.validation": "No data available currently",
  "add.room": "Add Room/Property",
  "edit.room": "Edit Room/Property",
  "building.zone": "Zone",
  "Floor.No": "Floor No.",
  "Room.No": "Block, Booth, Land(Deed), Room No.",
  "photo.upload": "Photo Upload",
  upload: "Upload",
  "qty.bedroom": "Qty Bedroom(s)",
  "Floor.Size": "Room/Property Size",
  "qty.toilet": "Qty Toilet(s)",
  "Facilities.heading": "Facilities",
  "fee.detail": "Fee Detail",
  "fee.item": "Fee Item No.",
  "fee.type": "Fee Type",
  "Price.month": "Price Per Month",
  Price: "Price",
  "Price.year": "Price Per Year ",
  "one-price": "One Time Payment",
  "merge-price": "Total Payment",
  "No.price": "No Price",
  "company.head": "Head office",

  // Cost Of Utilities //
  "btn.electric": "Electric Calculation",
  "btn.water": "Water calculation",
  "heading.cost": "Please fill out this form to receive an estimate.",
  "select.cost": "Select asset type.",
  "price.cost": "Price/Unit",
  "unit.cost": "Unit",
  "electricity.tariff": "Electricity tariff adjustment (Ft)",
  "btn.calculate": "Calculate",
  "btn.reset": "Reset Form",
  "Used.Energy": "Customer Used Energy",
  "Used.eset": "Customer Used Energy",
  "With.meter": "With meter",
  "without.meter": "without meter",
  "Electricity.Rate": " Progressive Electricity Rate",
  "Water.tariff": "Water tariffs",
  "utility-type": "Utility Type",
  "create-invoice": "Create Invoice",
  "edit-utilities": "Edit Utilities",
  "add-utilities": "Add Utilities",

  // Asset Name //
  "asset.Name": " Asset Name",
  "zone.delete": "Delete Zone",
  "zone.delete-use": "Alert !!",
  "delete.zone": "Do you want to delete this zone ?",
  "delete-use.zone": "Oops! This zone is used.",
  "floor.delete": "Delete Floor",
  "delete.floor": "Do you want to delete this floor ?",
  "room.poperty": "Room/property detail",
  "google.map.name": "Google Map",
  "building.zone.name": "Zone : ",
  "floor.no.name": "Floor No : ",
  "unit.bedroom": "Room(s)",
  "start.from": "Start From ",
  "crop.image": "Crop Image",
  "room.delete": "Delete Room/Property",
  "delete.rooms": "Do you want to delete this room/property ?",
  "delete.asset": "Delete Asset",
  "delete.asset-details": "Do you want to delete this asset ?",
  toilet: "Bathroom (s)",
  description: "Description",

  // button //
  "btn.addZone": "Add Zone",
  "btn.addFloor": "Add Floor",
  "btn.map.setup": "Map Setup",
  "btn.Personal": "Personal Information",
  "btn.payment": "Payment Information",
  "btn.Company": "Company Profile",
  "btn.change": "Change Password",
  "btn.logout": "Log out",
  "btn.close": "Close",
  "btn.adduser": "Add User",
  "btn.edit": "Edit",
  "button.cancel": "Cancel",
  "button.save": "Save",
  "button.done": "Done",
  "button.next": "Next",
  "button.add.asset": "Add Asset",
  "add.fee.detail": "Add Fee Detail",
  "btn.reset.all": "Reset All",
  "btn.edit.photo": "Edit Photo",
  "btn.addnew": "Add New",
  "btn.send": "Send",
  "btn.extend-stay": "Extend Stay",
  "btn.finish": "Finish",
  "btn.day": "Daily",
  "btn.month": "Monthly",
  "btn.year": "Yearly",
  "btn.submit": "Submit",
  "btn.selling": "Selling Now",
  "btn.selling-draft": "Selling Draft",

  // Asset Name //
  "input.nickName": "Nick Name",

  // Heading Modal //
  "modal.edituser": "Edit User",
  "modal.deletefee": "Delete Fee",
  "modal.mapsetup": "Map setup",
  "modal.editasset": "Edit Asset",
  "modal.editroom": "Edit Room/Property",

  // Delete Modal //
  "delete.fee": "Do you want to delete this Fee ?",

  // Warning Company
  "warning.organize.name.th": "Please enter a organization name (ภาษาไทย).",
  "warning.organize.name.en": "Please enter a organization name (English).",
  "warning.organize.license": "Please enter a organization license no.",
  "warning.organize.address.th":
    "Please enter a organization address (ภาษาไทย).",
  "warning.organize.address.en":
    "Please enter a organization address (English).",
  "warning.organize.country": "Please enter a organization country.",
  "warning.organize.province": "Please enter a organization province.",
  "warning.organize.district": "Please enter a organization district.",
  "warning.organize.subdistrict": "Please enter a organization sub district.",
  "warning.organize.postalcode": "Please enter a organization postal code.",
  "warning.organize.phone": "Please enter a organization phone.",
  "warning.organize.email": "Please enter a organization email.",
  "warning.company.branch": "Please enter a branch no.",
  "warning.company.address.th": "Please enter a address (ภาษาไทย).",
  "warning.company.address.en": "Please enter a address (English).",
  "warning.company.country": "Please enter a country.",
  "warning.company.province": "Please enter a province.",
  "warning.company.district": "Please enter a district.",
  "warning.company.subdistrict": "Please enter a sub district.",
  "warning.company.postalcode": "Please enter a postal code.",
  "warning.select-zone": "Please add a zone or select no zone.",

  // Warning Personal
  "warning.prefix": "Please select a prefix.",
  "warning.first.name": "Please enter a first name.",
  "warning.last.name": "Please enter a last name.",
  "warning.gender": "Please select a gender.",
  "warning.date": "Please enter a date of birth.",
  "warning.nationality": "Please select a nationality.",
  "warning.email": "Please enter a email.",
  "warning.id.passport": "Please enter a ID/Passport.",
  "warning.address": "Please enter a address.",
  "warning.country": "Please select a country.",
  "warning.province": "Please select a province.",
  "warning.district": "Please select a district.",
  "warning.subdistrict": "Please select a sub district.",
  "warning.postal": "Please enter a postal code.",
  "warning.mobile": "Please enter a mobile.",
  "warning.permiss": "Please select a permission.",

  // Warning Permission
  "warning.permission.name": "Please enter a permission name.",

  //Warning Asset
  "warning.asset.name": "Please enter a asset name.",
  "warning.asset.name-dropdown": "Please select a asset name.",
  "warning.asset.type": "Please select a asset type.",
  "warning.asset.map": "Please enter a google map URL.",
  "warning.room&property.name": "Please enter a room or property name.",
  "warning.block.no": "Please enter a block, booth, land(deed), room no.",
  "warning.block.duplicate":
    "This block number already exists, please use a different one.",
  "warning.block.no-dropdown":
    "Please select a block, booth, land(deed), room no.",
  "warning.zone": "Please select a zone.",
  "warning.zone-input": "Please enter a zone name.",
  "warning.floor": "Please select a floor.",
  "warning.floor-input": "Please enter a floor.",
  "warning.profile.room": "Please add a profile.",
  "warning.gallery": "Please add a gallery.",
  "warning.room&property.size": "Please enter a room or property size.",
  "warning.qty.bedroom": "Please enter a qty bedroom(s).",
  "warning.qty.toilet": "Please enter a qty toilet(s).",
  "warning.facilities": "Please select a facilities.",
  "warning.number-people": "Please enter a number of people.",
  "warning.number-duedate": "Please enter a due date.",
  "warning.start-date": "Please select a start date.",
  // "warning.dates": "Please select a date.",
  // "warning.payment-type": "Please select a payment type.",
  "warning.end-date": "Please select a end date.",
  "warning.due-date": "Please select a due date.",
  "warning.upload-files-doc": `Warning: It is not recommended to upload documents identifying you,
            such as a copy of your ID card, passport, and related documents, as
            they are at risk of violating the Personal Data Protection Act B.E.
            2019.`,
  "warning.booking-team-sale": `If you need to make any changes or would like more information, kindly reach out to our sales contact, `,
  "warning.date-expired": "The rental contract has expired.",
  "warning.date-expireds": "The rental contract is about to expire.",
  "warning.day-extend-stay": "Please enter the number of day.",
  "warning.price-extend-stay": "Please enter a additional charge.",
  "warning.month-extend-stay": "Please enter the number of month.",
  "warning.bank-name": "Please select a bank name.",
  "warning.account-name": "Please enter a account name.",
  "warning.account-number": "Please enter a account number.",
  "warning.dates": "Please select a date.",
  "warning.payment-type": "Please select a payment type.",
  "warning.remark": "Please select a remark.",
  "warning.email-address": "This email address is already in use.",
  "warning.price": "Please enter a price.",
  "warning.subject": "Please enter a subject.",
  "warning.status": "Please enter a status.",
  "warning.property-type": "Please select a property type.",
  "warning.guest-name": "Please select a guest name.",
  "warning.sale-team": "Please select a sales team.",
  "warning.legal-type": "Please select a legal entity.",
  "warning.company-name": "Please enter a company name.",
  "warning.corporate-number": "Please enter a corperate registration number.",
  "warning.relationship": "Please select a marital status.",

  // Map setup
  "modal.mepsetup": "Map Setup",
  "modal.add-mepsetup": "Add Map Setup",
  "modal.edit-mepsetup": "Edit Map Setup",
  "select-zone-floor": "Please Select Zone And Floor",
  "btn-download": "Download",
  "mepsetup-detail": "Map Setup Details",
  "delete.map": "Delete Map Setup",
  "delete-map-detail": "Do you want to delete this map ?",

  // Rental
  "modal-gallery": "Gallery",
  booking: "Booking",
  "booking-no": "Booking No.",
  list: "List",
  map: "Map",
  "search-zone": "Zone",
  "search-floor": "Floor",
  "head-modal-booking": "Booking Process",
  prefix: "Prefix",
  contact: "Contact",
  "number-people": "Number Of People",
  "start-date": "Start Date",
  "end-date": "End Date",
  "send-email": "Send To Email",
  print: "Print",
  "btn-save-draft": "Save as draft",
  "btn-book-now": "Book Now",
  "delete-booking": "Delete Booking Draft",
  "delete-booking-detail": "Do you want to delete this booking draft ?",
  "delete-selling": "Delete Selling Draft",
  "delete-selling-detail": "Do you want to delete this selling draft ?",
  "cancle-booking": "Cancel Booking",
  "cancle-booking-detail": "Do you want to cancle this booking ?",
  "finish-booking": "Finish Booking",
  "finish-booking-detail": "Do you need this reservation to be finalized ?",
  "extend-stay-day": "How Number Day(s) ?",
  "extend-stay-month": "How Number Month(s) ?",
  "extend-stay-price": "Additional Charge",
  "price-range": "Price Range",
  minimum: "Minimum Stay",
  "total-zone": "Total Zone",
  "total-unit": "Total Unit",
  "total-floor": "Total Floor",
  "permission-rent":
    "Would you like to contact a lawyer to draft a lease agreement or other legal contracts?",

  // Bill
  "document-no": "Document No.",
  "last-meter": "Last Meter",
  "new-meter": "New Meter",
  "total-price": "Total Price",
  "due-date": "Due Date",
  vat: "Vat 7%",
  discounts: "Discounts",
  remark: "Remark",
  "bank-name": "Bank Name",
  "account-name": "Account Name",
  "account-number": "Account Number",
  "qr-code": "QR Payment",
  "grand-total": "Grand Total",
  payment: "Payment",
  "payment-type": "Payment Type",
  cash: "Cash",
  transfer: "Transfer",
  "debit-credit": "Debit / Credit Cards",
  other: "Other",
  date: "Date",
  receipt: "Receipt",
  invoice: "Invoice",
  collector: "Collector",
  payer: "Payer",
  "delete-invoice": "Delete Invoice",
  "delete-invoice-detail": "Do you want to delete this invoice ?",
  year: "Year",
  month: "Month",
  "month-year": "Month/Year",

  // Sale
  "head-modal-selling": "Selling Process",
  "buyer-infor": "Buyer Information",
  "contract-infor": "Contract Information",
  "selling-confirm": "Selling Confirmation",
  "permission-sale":
    "Do you want to contact a lawyer to draft a contract for buying, selling, or other legal agreements?",
  "click-here": "Click here",
  "confirm-seller": "Confirm Seller Information",
  seller: "Seller",
  "selling-date": "Selling Date",
  "contract-date": "Contract Date",
  "transfer-date": "Ownership Transfer Date",
  "on-process": "On Process",
  "change-transfer-date": "Change Ownership Transfer Date",
  "payment-term": "Payment Period",
  "cancle-selling": "Cancel Selling",
  "payment-period": "Payment Period",
  subject: "Subject",
  subjects: "Subject(s)",
  status: "Status",
  paid: "Paid",
  dates: "Date",
  pending: "Pending",
  reason: "Reason",
  show: "Show",
  entries: "Entries",
  "no.": "No.",
  "guest-name": "Guest Name",
  "rental-fee": "Rental Fee",
  "grand-totals": "Grand Total",
  "payment-method": "Payment Method",
  "sale-no.": "Selling No.",
  "payment-date": "Payment Date",
  "booking-date": "Booking Date",
  "property-type": "Property Type",

  // Dashboard
  "total-properties": "Total Properties",
  "available-properties": "Available Properties",
  "occupied-properties": "Occupied Properties",
  "booking-overview": "Booked",
  "to-day": "Today",
  week: "Week",
  "property-rent-statistic": "Property Rent Statistic",
  "upcoming-booking": "Upcoming Booking",
  "upcoming-invoice": "Upcoming Invoice",
  "property-rent": "Property Rent",
  "property-sale": "Property Sales",
  action: "Action",
  "selling-no": "Selling No.",
  selling: "Property Sold",
  "sold-out": "Sold Out",
  sold: "Sold",
  "property-sale-statistic": "Property Statistic",
  "in-progress-status": "In Progress Status",
  revenue: "Revenue",
  "filter-price": "Filter Price",
  occupied: "Occupied",
  "issue-date": "Issue Date",
  "water-charge": "Water Charge",
  "elec-charge": "Electricity Charge",
  document: "Document",
  paids: "Paid",
  awaiting: "Awaiting Payment",
  awaitings: "Awaiting",
  zones: "zone(s)",
  units: "unit(s)",
  "booking-now": "Booking Now",
  "available/vacant": "Available/Vacant",
  details: "Details",
  "payment-details": "Payment Details",
  "related-document": "Related Document",
  "identity-confirmed": "Identity Confirmed",
  "send-mail": "Send Email",
  "no-information": "No Information",
  "warning.select-floor": "Please add a floor or select no floor.",
  "warning.add-room": "Please add a room/property.",
  "payment-plan": "Payment Plan",
  thb: "THB",
  months: "Month(s)",
  "no-of-month": "No. Of month(s)",
  "upload-profile": "*Photo size: wide 100 px x high 100 px | at least 100 KB",
  "upload-profile-type": "(File: *.png, *.jpg, *.jpeg, *.heic, *.heif.)",

  "gallery-asset":
    "*Photo size: at least 50 KB (File: *.png, *.jpg, *.jpeg, *.heic, *.heif.)",
  "gallery-asset-type":
    "*Photo size: at least 50 KB (File: *.png, *.jpg, *.jpeg.)",
  "upload-gallery": "Upload Gallery",
  "drag-and-drop": "Drag and drop files here or click to select files.",
  "duplicate-file": "Duplicate file name.",
  "allowed-formats": "Allowed formats: .png, .jpg, .jpeg, .heic, .heif.",
  "warning.size.img": "Image size must be more than 50KB.",
  "delete-success": "deleted successfully.",
  "click-upload": "Click to upload files, Drag and drop maps.",
  "file-size": "*Photo file: *.png, *.jpg, *.jpeg, *.heic, *.heif.",
  total: "Total",

  name: "Name",
  "invoice-no": "Invoice No.",
  issuer: "Issuer",
  recipient: "Recipient",
  "receipt-no": "Receipt No.",
  "select-year": "Select Year",
  "unit(s)": "Unit(s)",
  "price-per-unit": "Price Per Unit",

  "signed-agreement-document": "Signed Agreement Document",
  "dont-have-agreement": "Don’t Have Agreement",
  "add-agreement": "Please add the agreement file.",
  "click-upload-file": "Drop files here or click to upload",
  "relates-document": "Relates Document",

  "confirm-rent": "Request for a lawyer",
  lessor: "Lessor",
  bedrooms: "Bedroom(s)",
  "thb-per-month": "THB Per Month",
  "cost-utilities": "Cost Of Utilities",
  "booking-draft": "Booking Draft",
  "lessee-information": "Lessee Information",
  "rental-information": "Rental Information",
  "booking-information": "Booking Confirmation",
  all: "All",
  vacant: "Vacant",
  "sales-team": "Sales Team",
  wait: "Please Wait..",
  "add-item": "Please enter item",
  "btn-add-item": "Add Item",
  "marital-status": "Marital Status",
  single: "Single",
  married: "Married",
  "corporate-entity": "Legal Entity",
  "type-legal-entity": "Type Of Legal Entity",
  "corporate-registration-number": "Corporate Registration Number",
  "registration-no": "Registration No.",
  "head-contract-expired": "Cancel the lease or sell this property/room",
  "contract-expired": "Do you want to terminate the lease or sell this room?",
  "contract-expired-next":
    "Cancelling this contract will remove all access to this room’s information.",
  "limit-room": "You have reached your asset addition limit.",
  responsible: "Responsible for",
  "occupied-properties-sale": "This property has been sold out.",
  "merge-bill": "Merge",
  "alert-utility":
    "Please enter the meter information before generating the invoice.",
  "alert-merge": "Please create a bill before selecting to merge bills.",

  "edit-invoice": "Edit Invoice",
  "edit-rental-fee": "Case of changing the rent",
  "this-bill": "Only this bill",
  throughout: "Throughout contract",
  "alert-cost": "Please press save or cancel before changing the month.",
  "want-to-pay": "Want to pay",
  number: "Quantity",
  "billing-cycle": "It's the billing cycle.",
  "still-more-left": "There's still more left.",
  "revenue.type": "Revenue Type",
  "payment-completed": "Payment completed.",
  "overdue-payment": "Overdue Payment",
};
